// extracted by mini-css-extract-plugin
module.exports = {"defaultTheme":"styles_defaultTheme__2pyNJ"};